// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-bottom-dashed[data-v-784129f0]{display:block;height:.5px;width:80%;margin:0 auto;border:unset;border-bottom:2px dashed #ccc}.rounded-last-child[data-v-784129f0]{border-radius:0}.rounded-last-child[data-v-784129f0]:last-child{border-radius:0 0 8px 8px}", ""]);
// Exports
module.exports = exports;
